import { Icon } from "react-migration/components/Icon";
import { Layer } from "react-migration/layouts/map/Multilayer/types";

interface OutsideZoomLimitMessageProps {
  layer: Layer;
}

export function OutsideZoomLimitMessage({ layer }: OutsideZoomLimitMessageProps) {
  return (
    <div className="flex items-center gap-4">
      <div>
        <Icon size="lg" icon="icon-lt-error-warning-line" extraClasses="text-amber-600" />
      </div>
      <div className="flex flex-col gap-2">
        <div className="text-xs font-semibold text-blue-grey-950">Unknown</div>
        <div className="text-xs text-blue-grey-900">
          We&apos;re unable to show considerations for &quot;{layer.title}&quot; at your current zoom level. Please
          adjust your zoom and try again
        </div>
      </div>
    </div>
  );
}
